import { ReactNode } from 'react';
import { Organization } from '@/types/organization';
import { OrganizationContext } from '@/context/organization-provider';

interface OrganizationDetailProviderProps {
  organization: Organization;
  children: ReactNode;
}

/**
 * Simple provider to wrap the organization detail page
 * Provides organization context to reused components
 * Reuses the OrganizationContext from the main provider for compatibility
 */
export const OrganizationDetailProvider = ({ organization, children }: OrganizationDetailProviderProps) => {
  const contextValue = {
    organization,
    membership: null,
    isLoading: false,
    error: null,
    subdomain: organization.subdomain,
    hasOrganizationAccess: true, // Super admin has access
    organizationRole: 'admin',
    isOrganizationAdmin: true,
  };

  return (
    <OrganizationContext.Provider value={contextValue}>
      {children}
    </OrganizationContext.Provider>
  );
};
